import { inject, Injectable, makeStateKey, TransferState } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);
  private readonly transferState = inject(TransferState);

  getTranslation(lang: string): Observable<Translation> {
    const key = makeStateKey<Translation>(`transloco-${lang}`);

    // On the browser, reuse the translation serialized by the server render.
    const cached = this.transferState.get(key, null);
    if (cached) {
      this.transferState.remove(key);
      return of(cached);
    }

    return this.http.get<Translation>(`/assets/i18n/${lang}.json`).pipe(
      // On the server, hand the translation to the browser to avoid a second fetch.
      tap((translation) => this.transferState.set(key, translation)),
    );
  }
}
